// import React, { useState, useEffect } from "react";
// import { FiEdit, FiMail, FiSave, FiX } from "react-icons/fi";
// import TextInput from "../../components/ui/TextInput";
// import { useAuthStore } from "../../context/useAuthStore";
// import toast from "react-hot-toast";
// import { validateEmail } from "../../utils/validation";
// import PhoneNumberInput from "../../components/ui/PhoneNumberInput";
// import { LuBuilding2, LuCalendar, LuMapPin, LuUser } from "react-icons/lu";
// import { LiaIdCard } from "react-icons/lia";

// // Types for form and errors
// type FormDataKeys =
//   | "userId"
//   | "fullName"
//   | "emailId"
//   | "roleId"
//   | "phoneNumber"
//   | "college"
//   | "address"
//   | "yearOfStudy"
//   | "rollNumber";

// type ValidationKeys = "emailId" | "phoneNumber";

// const ProfilePage: React.FC = () => {
//   const { user, updateUser, isLoading } = useAuthStore();
//   const [editMode, setEditMode] = useState(false);

//   const [formData, setFormData] = useState<Record<FormDataKeys, string>>({
//     userId: "",
//     fullName: "",
//     emailId: "",
//     roleId: "",
//     phoneNumber: "",
//     college: "",
//     address: "",
//     yearOfStudy: "",
//     rollNumber: "",
//   });

//   const [errors, setErrors] = useState<Record<ValidationKeys, string>>({
//     emailId: "",
//     phoneNumber: "",
//   });

//   // Keep formData in sync with store user
//   useEffect(() => {
//     if (user) {
//       setFormData({
//         userId: user.userId || "",
//         fullName: user.fullName || "",
//         emailId: user.emailId || "",
//         roleId: user.roleId || "",
//         phoneNumber: user.phoneNumber || "",
//         college: user.college || "",
//         address: user.address || "",
//         yearOfStudy: user.yearOfStudy || "",
//         rollNumber: user.rollNumber || "",
//       });
//     }
//   }, [user]);

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));

//     if (errors[name as ValidationKeys]) {
//       setErrors((prev) => ({ ...prev, [name]: "" }));
//     }
//   };

//   const handlePhoneChange = (value: string) => {
//     setFormData((prev) => ({ ...prev, phoneNumber: value }));
//     if (errors.phoneNumber) {
//       setErrors((prev) => ({ ...prev, phoneNumber: "" }));
//     }
//   };

//   const validateField = (fieldName: ValidationKeys, value: string) => {
//     let error = "";
//     if (!value.trim()) {
//       error = "This field is required";
//     } else {
//       if (fieldName === "emailId" && !validateEmail(value)) {
//         error = "Please enter a valid email address";
//       }
//       if (fieldName === "phoneNumber" && value.replace(/\D/g, "").length < 10) {
//         error = "Please enter a valid phone number";
//       }
//     }
//     return error;
//   };

//   const validateForm = () => {
//     let isValid = true;
//     const newErrors: Record<ValidationKeys, string> = { ...errors };

//     (["emailId", "phoneNumber"] as ValidationKeys[]).forEach((key) => {
//       const error = validateField(key, formData[key]);
//       if (error) {
//         newErrors[key] = error;
//         isValid = false;
//       }
//     });

//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleEdit = () => setEditMode(true);

//   const handleCancel = () => {
//     if (!user) return;
//     setFormData({
//       userId: user.userId,
//       fullName: user.fullName,
//       emailId: user.emailId,
//       roleId: user.roleId,
//       phoneNumber: user.phoneNumber,
//       college: user.college,
//       address: user.address,
//       yearOfStudy: user.yearOfStudy,
//       rollNumber: user.rollNumber,
//     });
//     setErrors({ emailId: "", phoneNumber: "" });
//     setEditMode(false);
//   };

//   const handleSave = async () => {
//     if (!user) return;

//     if (!validateForm()) {
//       toast.error("Please fix the errors before saving");
//       return;
//     }

//     try {
//       const updatedData = {
//         ...formData,
//         emailId: formData.emailId.trim().toLowerCase(),
//         phoneNumber: formData.phoneNumber.trim(),
//       };
//       await updateUser(updatedData); // store handles success/error toast
//       setEditMode(false);
//     } catch (error) {
//       console.error("Profile update error:", error);
//       toast.error("Failed to update profile. Please try again.");
//     }
//   };

//   if (!user) {
//     return <p className="text-gray-500">No user data available.</p>;
//   }

//   const fields = [
//     {
//       id: "name",
//       name: "fullName",
//       label: "Full Name",
//       type: "text",
//       value: formData.fullName,
//       disabled: true,
//       icon: LuUser,
//     },
//     {
//       id: "email",
//       name: "emailId",
//       label: "Email Address",
//       type: "email",
//       value: formData.emailId,
//       disabled: !editMode,
//       icon: FiMail,
//       onChange: handleChange,
//       errorMessage: errors.emailId,
//     },
//     {
//       id: "mobile",
//       name: "phoneNumber",
//       label: "Mobile Number",
//       type: "text",
//       value: formData.phoneNumber,
//       disabled: !editMode,
//       onChange: handleChange,
//       errorMessage: errors.phoneNumber,
//       phone: true,
//     },
//     {
//       id: "college",
//       name: "college",
//       label: "College Name",
//       type: "text",
//       value: formData.college,
//       icon: LuBuilding2,
//       disabled: true,
//     },
//     {
//       id: "address",
//       name: "address",
//       label: "Address",
//       type: "text",
//       value: formData.address,
//       icon: LuMapPin,
//       disabled: true,
//     },
//     {
//       id: "yearOfStudy",
//       name: "yearOfStudy",
//       label: "Year of Study",
//       type: "text",
//       value: formData.yearOfStudy,
//       icon: LuCalendar,
//       disabled: true,
//     },
//     {
//       id: "roll",
//       name: "rollNumber",
//       label: "Roll Number",
//       type: "text",
//       value: formData.rollNumber,
//       icon: LiaIdCard,
//       disabled: true,
//     },
//   ];

//   return (
//     <>
//       <div className="min-h-[calc(100%-theme(space.2))] bg-myLight pl-2 pb-4">
//         <section className="border-b border-myInputBorder/60 mb-4 bg-transparent backdrop-blur-md w-full sticky z-30 top-0 p-4">
//           <div className="max-w-5xl mx-auto px-4">
//             <h1 className="text-2xl font-bold text-myLabelText capitalize">
//               Account
//             </h1>
//           </div>
//         </section>

//         <section className="max-w-5xl mx-auto">
//           <div className="subjectHeader flex items-center justify-between pb-2 pt-0">
//             <h2 className="subjectTitle text-xl font-semibold">My Profile</h2>
//             {!editMode ? (
//               <button
//                 onClick={handleEdit}
//                 className="subjectBtn flex items-center gap-2"
//               >
//                 <FiEdit size={20} /> Edit
//               </button>
//             ) : (
//               <div className="flex gap-3">
//                 <button
//                   onClick={handleSave}
//                   disabled={isLoading}
//                   className={`px-4 py-2 rounded-full flex items-center gap-2 text-sm font-semibold ${
//                     isLoading
//                       ? "bg-green-300 text-white cursor-not-allowed"
//                       : "bg-green-600 text-white cursor-pointer"
//                   }`}
//                 >
//                   <FiSave size={18} /> {isLoading ? "Saving..." : "Save"}
//                 </button>
//                 <button
//                   onClick={handleCancel}
//                   className="bg-gray-300 text-gray-800 px-4 py-2 rounded-full flex items-center gap-2 text-sm font-semibold cursor-pointer"
//                 >
//                   <FiX size={18} /> Cancel
//                 </button>
//               </div>
//             )}
//           </div>

//           <section className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 sm:gap-y-0 gap-y-2.5 pr-4 pl-1">
//             {fields.map(
//               ({
//                 id,
//                 name,
//                 label,
//                 type,
//                 value,
//                 disabled,
//                 errorMessage,
//                 phone,
//                 icon,
//               }) => {
//                 if (phone) {
//                   return (
//                     <PhoneNumberInput
//                       key={id}
//                       value={formData.phoneNumber}
//                       onChange={handlePhoneChange}
//                       label={label}
//                       required
//                       errorMessage={errors.phoneNumber}
//                       disabled={!editMode}
//                     />
//                   );
//                 }

//                 return (
//                   <TextInput
//                     key={id}
//                     id={id}
//                     name={name}
//                     label={label}
//                     type={type}
//                     value={value}
//                     onChange={handleChange}
//                     disabled={disabled}
//                     errorMessage={errorMessage}
//                     icon={icon}
//                   />
//                 );
//               }
//             )}
//           </section>
//         </section>
//       </div>
//     </>
//   );
// };

// export default ProfilePage;

import React,{useState} from "react";
import UserProfile from "../../components/ui/UserProfile";
import SubjectTabs from "../../components/common/SubjectTabs";
import MyInvoices from "../../components/ui/MyInvoices";

const ProfilePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <div className="min-h-[calc(100%-theme(space.2))] bg-myLight pl-2 pb-4">
      <section className="border-b border-myInputBorder/60 bg-transparent backdrop-blur-md w-full sticky z-30 top-0 p-4">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="text-2xl font-bold text-myLabelText capitalize">
            Account
          </h1>
        </div>
      </section>
      <section className="max-w-5xl mx-auto">
      <SubjectTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabs={[
          {
            label: "Profile",
            content: <UserProfile />
          },
          {
            label: "Invoices",
            content: <MyInvoices />
          }
        ]}
      />
      </section>
    </div>
  );
};

export default ProfilePage;
